import { KanbanSquare, List } from 'lucide-react';
import type { TrackerView } from '@/components/tracker/tracker.types';
import { cx } from '@/cva.config';

interface ViewToggleProps {
  onChange: (view: TrackerView) => void;
  view: TrackerView;
}

export const ViewToggle = ({ onChange, view }: ViewToggleProps) => (
  <div className="flex rounded-md border border-border bg-surface p-0.5">
    <button
      className={cx(
        'flex items-center gap-1.5 rounded-sm px-2.5 py-1 text-xs lg:text-sm transition-colors',
        view === 'kanban'
          ? 'bg-border/60 text-foreground'
          : 'text-foreground-muted hover:text-foreground',
      )}
      onClick={() => onChange('kanban')}
      type="button"
    >
      <KanbanSquare className="size-3.5" /> Kanban
    </button>
    <button
      className={cx(
        'flex items-center gap-1.5 rounded-sm px-2.5 py-1 text-xs lg:text-sm transition-colors',
        view === 'list'
          ? 'bg-border/60 text-foreground'
          : 'text-foreground-muted hover:text-foreground',
      )}
      onClick={() => onChange('list')}
      type="button"
    >
      <List className="size-3.5" /> List
    </button>
  </div>
);
